import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormControlErrorDictionary } from 'src/app/shared/constants/FormControlErrorDictionary';
import { FormControlError } from 'src/app/shared/enums/FormControlError';

@Pipe({
  name: 'formatControlErrors',
  pure: false,
  standalone: true,
})
export class FormControlErrorsPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(control: FormControl): string[] {
    const errorMessages = [];

    Object.entries(control.errors).forEach(([errorKey]) => {
      const errorMessageKey = FormControlErrorDictionary[errorKey];

      if (control.hasError(FormControlError.MIN_LENGTH)) {
        errorMessages.push(
          this.translate.instant(errorMessageKey, {
            requiredLength: control.errors[FormControlError.MIN_LENGTH].requiredLength,
          }),
        );
      } else if (control.hasError(FormControlError.MAX_LENGTH)) {
        errorMessages.push(
          this.translate.instant(errorMessageKey, {
            requiredLength: control.errors[FormControlError.MAX_LENGTH].requiredLength,
          }),
        );
      } else if (control.hasError(FormControlError.INVALID_PASSWORD)) {
        errorMessages.push(control.errors[FormControlError.INVALID_PASSWORD].passwordValidationMessage);
      } else if (errorMessageKey) {
        errorMessages.push(this.translate.instant(errorMessageKey));
      }
    });

    return errorMessages;
  }
}
